import { makeAutoObservable } from 'mobx'
import enter from 'src/assets/images/common/enter.svg'
import { isAdmin } from '../../../services/AccountService'
import { assignServiceOrderOnDealerGroup } from '../../../services/ApiService'
import { notifySuccess } from '../../../services/ToastifyService/ToastifyService'
import { gState } from '../../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import { getComp } from '../../../utils/utils/DI'
import getNoun from '../../../utils/utils/getNoun'

class ServiceSelectOrdersStore {
  constructor() {
    this.isAssignDealerDrawerOpen = false
    this.newDealer = null
    this.selectedOrders = new Set()
    this.selectedOrder = null
    this.ordersStore = getComp('ServiceStore')
    this.dealersStore = getComp('DealersStore')

    makeAutoObservable(this)
  }

  get isTableRowSelected() {
    return this.isOrdersSelected
  }

  getActionTabs = () => {
    return [
      {
        name: gState['intl'].formatMessage({ id: 'Назначить дилера' }),
        action: this.toggleAssignDealerDrawer,
        icon: enter,
        isActive: isAdmin(),
      },
    ]
  }

  clearSelectOrders = () => {
    this.selectedOrders.clear()
  }
  clearSelectOrder = () => {
    this.selectedOrder = null
  }

  get isOrdersSelected() {
    return !!this.selectedOrders.size
  }

  // принимает айдишник заявки из чекбоксов
  selectOrder = (id) => {
    if (this.selectedOrders.has(id)) {
      this.selectedOrders.delete(id)
    } else {
      this.selectedOrders.add(id)
    }
  }

  // принимает айдишник заявки из таблицы
  selectOrderFromDrawer = (id) => {
    this.selectedOrder = [id]
  }

  toggleAssignDealerDrawer = (ids) => {
    if (ids?.length) {
      this.selectedOrders = new Set(ids)
    }

    this.newDealer = null
    this.isAssignDealerDrawerOpen = !this.isAssignDealerDrawerOpen
  }

  assignDealer = (store, action) => {
    const orderIds = this.selectedOrder
      ? this.selectedOrder
      : this.selectedOrders

    const size = Array.isArray(orderIds) ? orderIds.length : orderIds.size
    const dealer = this.dealersStore.getDealer(this.newDealer)

    openModalFn['progress-backdrop']()
    const params = {
      dealerId: dealer?.subjectId,
      orderIds: orderIds,
    }

    assignServiceOrderOnDealerGroup(params)
      .then((res) => {
        if (store) {
          store.reLoad()
        }

        if (action) {
          action(res)
        }

        if (!isAdmin()) {
          this.ordersStore.reLoad()
        }

        this.clearSelectOrders()

        this.toggleAssignDealerDrawer()
      })
      .catch((err) => {
        closeModalFn['progress-backdrop']()
      })
      .finally(() => {
        closeModalFn['progress-backdrop']()
        const message = gState['intl'].formatMessage(
          {
            id: '{size} {sizeNoun} {sizeNounAction} на дилера {dealer}',
            defaultMessage: `{size} {sizeNoun} {sizeNounAction} на дилера {dealer}`,
          },
          {
            size: size,
            sizeNoun: getNoun(size, 'заявка', 'заявки', 'заявок'),
            sizeNounAction: getNoun(
              size,
              'назначена',
              'назначены',
              'назначены',
            ),
            dealer: dealer.displayName,
          },
        )
        notifySuccess(message)
        this.clearSelectOrders()
        closeModalFn['assign-dealer-submit-dialog']()
      })
  }
}

export default ServiceSelectOrdersStore
